import React, { useState, useEffect } from "react";

const HeroText = () => {
  const fullText = "Dados que transformam, estratégias que conectam";
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);
  const [pause, setPause] = useState(false);

  useEffect(() => {
    if (pause) return; // pausa temporária

    const speed = 100;

    const timeout = setTimeout(() => {
      if (!deleting) {
        setDisplayedText(fullText.slice(0, index + 1));
        if (index + 1 === fullText.length) {
          // pausa antes de apagar
          setPause(true);
          setTimeout(() => {
            setDeleting(true);
            setPause(false);
          }, 1000); // 1 segundo de pausa
        } else {
          setIndex(index + 1);
        }
      } else {
        setDisplayedText(fullText.slice(0, index - 1));
        if (index - 1 === 0) {
          setDeleting(false);
        }
        setIndex(index - 1);
      }
    }, speed);

    return () => clearTimeout(timeout);
  }, [index, deleting, pause]);

  return (
    <h3 style={{ display: "inline-block", maxWidth: "25vw", lineHeight: "1.4" }}>
      {displayedText}
      <span className="cursor">|</span>
    </h3>
  );
};

export default HeroText;
